import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=02f20ce6&scoped=true&"
import script from "./NavItem.vue?vue&type=script&lang=ts&"
export * from "./NavItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=02f20ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f20ce6",
  null
  
)

export default component.exports